import React, { useState } from 'react';
import { Form, Button, Card } from 'react-bootstrap';
import { Row, Col } from 'antd';

function SearchFunction() {
    const [books, setBooks] = useState([
    {
        coverImage: 'https://cdnec.sanmin.com.tw/product_images/626/626721930.jpg',
        title: '大地之歌',
        author: '哈利',
        isbn: '9786267219300',
        publisher: '檸樹林文化',
        publish_date: '2024-04-02',
        version: '初版',
        collection_size: 1,
    },
    {
        coverImage: 'https://cdnec.sanmin.com.tw/product_images/722/722111510.jpg',
        title: '海洋奇遇記',
        author: '約翰．史密斯',
        isbn: '9781234567890',
        publisher: '深海出版社',
        publish_date: '2023-09-10',
        version: '二版',
        collection_size: 2,
    },
    {
        coverImage: 'https://covers.openlibrary.org/b/id/10566258-L.jpg',
        title: 'To Kill a Mockingbird',
        author: 'Harper Lee',
        isbn: '9780060935467',
        publisher: 'Harper Perennial Modern Classics',
        publish_date: '2006-07-05',
        version: '50th Anniversary Edition',
        collection_size: 5,
    },
    {
        coverImage: 'https://covers.openlibrary.org/b/id/9276243-L.jpg',
        title: '1984',
        author: 'George Orwell',
        isbn: '9780451524935',
        publisher: 'Signet Classic',
        publish_date: '1961-07-01',
        version: 'Reprint Edition',
        collection_size: 8,
    },
    {
        coverImage: 'https://covers.openlibrary.org/b/id/10565078-L.jpg',
        title: 'The Great Gatsby',
        author: 'F. Scott Fitzgerald',
        isbn: '9780743273565',
        publisher: 'Scribner',
        publish_date: '2004-09-30',
        version: 'Reprint Edition',
        collection_size: 4,
    },
    {
        coverImage: 'https://covers.openlibrary.org/b/id/8322424-L.jpg',
        title: 'Pride and Prejudice',
        author: 'Jane Austen',
        isbn: '9780141040349',
        publisher: 'Penguin Classics',
        publish_date: '2009-05-28',
        version: 'Deluxe Edition',
        collection_size: 6,
    },
    {
        coverImage: 'https://covers.openlibrary.org/b/id/8235110-L.jpg',
        title: 'The Catcher in the Rye',
        author: 'J.D. Salinger',
        isbn: '9780316769488',
        publisher: 'Little, Brown and Company',
        publish_date: '2001-01-30',
        version: 'Reissue Edition',
        collection_size: 7,
    },
    ]);

    const [searchQuery, setSearchQuery] = useState(''); // 搜尋關鍵字
    const [currentPage, setCurrentPage] = useState(1);  // 當前頁數
    const [booksPerPage, setBooksPerPage] = useState(3);  // 每頁顯示書籍數量

    const styles = {
        searchContainer: {
            margin: '20px',
            justifyContent: 'center',
            alignItems: 'center',
        },
        selectStyle: {
            backgroundColor: 'white',
            border: '2px solid #2f7c9d',
            color: '#2f7c9d',
            borderRadius: '50px',
            width: '100%',
            textAlign: 'center',
            padding: '5px',
        },
        searchInput: {
            borderRadius: '50px',
            border: '2px solid #2f7c9d',
            padding: '5px 20px',
            width: '100%',
        },
        searchButton: {
            backgroundColor: '#f28d35',
            border: 'none',
            borderRadius: '50px',
            padding: '5px 20px',
            color: 'white',
            width: '100%',
        },
        informationButton: {
            backgroundColor: '#f28d35',
            border: 'none',
            borderRadius: '50px',
            padding: '5px 20px',
            color: 'white',
            width: '20%',
        },
        cardStyle: {
            marginTop: '20px',
            border: '1px solid #eaeaea',
            borderRadius: '10px',
            padding: '15px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        },
        titleStyle: {
            fontSize: '30px', // 調整字體大小
            fontWeight: 'bold', // 設置粗體
        },
        imageStyle: {
            width: '100px',
            height: 'auto',
        },
        paginationButton: {
            margin: '5px',
            padding: '5px 10px',
            border: '1px solid #2f7c9d',
            borderRadius: '5px',
            cursor: 'pointer',
        },
        disabledButton: {
            margin: '5px',
            padding: '5px 10px',
            border: '1px solid #ccc',
            borderRadius: '5px',
            cursor: 'not-allowed',
            color: '#ccc',
        },
        activeButton: {
            backgroundColor: '#2f7c9d',
            color: 'white',
            border: '2px solid #2f7c9d',
            borderRadius: '20px',
            width: '100%',
            margin: '5px 0',
        },
        inactiveButton: {
            backgroundColor: 'white',
            color: '#2f7c9d',
            border: '2px solid #2f7c9d',
            borderRadius: '20px',
            width: '100%',
            margin: '5px 0',
        },
        sectionTitle: {
            fontSize: '18px',
            fontWeight: 'bold',
        },
        buttonGroup: {
            margin: '5px 0',
        }
    };

    // 計算當前頁要顯示的書籍
    const indexOfLastBook = currentPage * booksPerPage;
    const indexOfFirstBook = indexOfLastBook - booksPerPage;
    const currentBooks = books.slice(indexOfFirstBook, indexOfLastBook);

    const totalPages = Math.ceil(books.length / booksPerPage);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleBooksPerPageChange = (e) => {
        setBooksPerPage(parseInt(e.target.value)); // 更新每頁顯示書籍數量
        setCurrentPage(1); // 重置頁碼回到第一頁
    };

    const [selectedCollection, setSelectedCollection] = useState('OT館藏區1'); // 館藏區選擇
    const [selectedBookType, setSelectedBookType] = useState('電子書'); // 藏書種類
    const [selectedYear, setSelectedYear] = useState('2024'); // 出版年選擇

    const handleCollectionClick = (collection) => {
        setSelectedCollection(collection);
    };

    const handleBookTypeClick = (type) => {
        setSelectedBookType(type);
    };

    const handleYearClick = (year) => {
        setSelectedYear(year);
    };

    return (
        <div style={styles.searchContainer}>
            <Row gutter={[16, 16]} align="middle">
                <Col span={4}>
                    <Form.Control as="select" style={styles.selectStyle}>
                        <option>全部</option>
                        <option>館藏</option>
                        <option>電子書</option>
                        <option>論文</option>
                    </Form.Control>
                </Col>
                <Col span={13}>
                    <Form.Control
                        type="text"
                        placeholder="輸入查詢內容"
                        style={styles.searchInput}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </Col>
                <Col span={4}>
                    <Form.Control as="select" style={styles.selectStyle}>
                        <option>全部</option>
                        <option>館藏</option>
                        <option>電子書</option>
                        <option>論文</option>
                    </Form.Control>
                </Col>
                <Col span={3}>
                    <Button style={styles.searchButton}>查詢</Button>
                </Col>
            </Row>
            <Row gutter={[16, 16]} align="middle" style={{ paddingTop: '10px', justifyContent: 'flex-end'  }}>
                <Col span={1} style={{ textAlign: 'right' }}>
                    排序
                </Col>
                <Col span={3}>
                    <Form.Control as="select" style={styles.selectStyle}>
                        <option>書名</option>
                        <option>作者</option>
                    </Form.Control>
                </Col>
                <Col span={1} style={{ textAlign: 'right' }}>
                    顯示
                </Col>
                <Col span={3}>
                    <Form.Control as="select" style={styles.selectStyle}>
                        <option>10</option>
                        <option>20</option>
                        <option>50</option>
                    </Form.Control>
                </Col>
                <Col span={2} style={{ textAlign: 'right', marginLeft: '-30px' }}>
                    筆資料
                </Col>
            </Row>
            <Row gutter={[16, 16]}>
                <Col span={20}>
                    {/* 動態書籍展示區塊 */}
                    {currentBooks.map((book, index) => (
                        <Card key={index} style={styles.cardStyle}>
                            <Row gutter={[16, 16]}>
                                <Col span={4}>
                                    <img src={book.coverImage} alt="書籍封面" style={styles.imageStyle} />
                                </Col>
                                <Col span={20}>
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                        <h1 style={styles.titleStyle}>{book.title}</h1>
                                        <p>作者: {book.author}</p>
                                        <p>ISBN: {book.isbn}</p>
                                        <p>出版資料: {book.publisher}</p>
                                        <p>出版日期: {book.publish_date}</p>
                                        <p>版本項: {book.version}</p>
                                        <p>館藏量: {book.collection_size}</p>
                                        </Col>
                                        <Col span={24} style={{textAlign: 'right'}}>
                                            <Button style={styles.informationButton}>館藏資訊</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    ))}
                    {/* 分頁按鈕 */}
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <button
                            onClick={handlePrevPage}
                            style={currentPage === 1 ? styles.disabledButton : styles.paginationButton}
                            disabled={currentPage === 1}
                        >
                            上一頁
                        </button>
                        {/* 頁碼按鈕 */}
                        {[...Array(totalPages)].map((_, index) => (
                            <button
                                key={index}
                                onClick={() => handlePageClick(index + 1)}
                                style={currentPage === index + 1 ? styles.activePageButton : styles.paginationButton}
                            >
                                {index + 1}
                            </button>
                        ))}
                        <button
                            onClick={handleNextPage}
                            style={currentPage === totalPages ? styles.disabledButton : styles.paginationButton}
                            disabled={currentPage === totalPages}
                        >
                            下一頁
                        </button>
                    </div>
                </Col>
                <Col span={4}>
                    <p style={{fontSize: '25px', fontWeight: 'bold', paddingTop: '15px', paddingBottom: '10px' }}>好書推薦</p>

                    {/* 館藏區選擇 */}
                    <div style={styles.sectionTitle}>館藏區</div>
                    <div style={styles.buttonGroup}>
                        <Button 
                            style={selectedCollection === 'OT館藏區1' ? styles.activeButton : styles.inactiveButton}
                            onClick={() => handleCollectionClick('OT館藏區1')}
                        >
                            OT館藏區1
                        </Button>
                        <Button 
                            style={selectedCollection === 'OT館藏區2' ? styles.activeButton : styles.inactiveButton}
                            onClick={() => handleCollectionClick('OT館藏區2')}
                        >
                            OT館藏區2
                        </Button>
                        <Button 
                            style={selectedCollection === 'OT館藏區3' ? styles.activeButton : styles.inactiveButton}
                            onClick={() => handleCollectionClick('OT館藏區3')}
                        >
                            OT館藏區3
                        </Button>
                    </div>

                    {/* 藏書種類選擇 */}
                    <div style={styles.sectionTitle}>藏書種類</div>
                    <div style={styles.buttonGroup}>
                        <Button 
                            style={selectedBookType === '期刊' ? styles.activeButton : styles.inactiveButton}
                            onClick={() => handleBookTypeClick('期刊')}
                        >
                            期刊
                        </Button>
                        <Button 
                            style={selectedBookType === '電子書' ? styles.activeButton : styles.inactiveButton}
                            onClick={() => handleBookTypeClick('電子書')}
                        >
                            電子書
                        </Button>
                        <Button 
                            style={selectedBookType === '西文書' ? styles.activeButton : styles.inactiveButton}
                            onClick={() => handleBookTypeClick('西文書')}
                        >
                            西文書
                        </Button>
                    </div>

                    {/* 出版年選擇 */}
                    <div style={styles.sectionTitle}>出版年</div>
                    <div style={styles.buttonGroup}>
                        <Button 
                            style={selectedYear === '2022' ? styles.activeButton : styles.inactiveButton}
                            onClick={() => handleYearClick('2022')}
                        >
                            2022
                        </Button>
                        <Button 
                            style={selectedYear === '2023' ? styles.activeButton : styles.inactiveButton}
                            onClick={() => handleYearClick('2023')}
                        >
                            2023
                        </Button>
                        <Button 
                            style={selectedYear === '2024' ? styles.activeButton : styles.inactiveButton}
                            onClick={() => handleYearClick('2024')}
                        >
                            2024
                        </Button>
                    </div>
                </Col>
            </Row>
            
        </div>
    );
}

export default SearchFunction;
